var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNinjaCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_7206)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66307 9.5687C7.23949 9.5687 9.3281 7.5941 9.3281 5.15832C9.3281 2.72253 7.23949 0.747932 4.66307 0.747932C2.08665 0.747932 -0.00195312 2.72253 -0.00195312 5.15832C-0.00195312 7.5941 2.08665 9.5687 4.66307 9.5687Z",
    fill: "#E18A04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66307 9.05944C7.23949 9.05944 9.3281 7.08484 9.3281 4.64905C9.3281 2.21327 7.23949 0.23867 4.66307 0.23867C2.08665 0.23867 -0.00195312 2.21327 -0.00195312 4.64905C-0.00195312 7.08484 2.08665 9.05944 4.66307 9.05944Z",
    fill: "#E4A020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66307 0.473938C2.08633 0.473938 -0.00195312 2.44824 -0.00195312 4.88432C-0.00195312 7.32041 2.08633 9.29471 4.66307 9.29471C7.23981 9.29471 9.3281 7.32041 9.3281 4.88432C9.3281 2.44824 7.23981 0.473938 4.66307 0.473938ZM4.66307 8.76277C2.3978 8.76277 0.560694 7.02668 0.560694 4.88432C0.560694 2.74197 2.3978 1.00587 4.66307 1.00587C6.92835 1.00587 8.76545 2.74197 8.76545 4.88432C8.76545 7.02668 6.92912 8.76277 4.66307 8.76277Z",
    fill: "#E18A04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66307 0.23867C2.08633 0.23867 -0.00195312 2.21297 -0.00195312 4.64905C-0.00195312 7.08514 2.08633 9.05944 4.66307 9.05944C7.23981 9.05944 9.3281 7.08514 9.3281 4.64905C9.3281 2.21297 7.23981 0.23867 4.66307 0.23867ZM4.66307 8.5275C2.3978 8.5275 0.560694 6.79141 0.560694 4.64905C0.560694 2.5067 2.3978 0.770605 4.66307 0.770605C6.92835 0.770605 8.76545 2.5067 8.76545 4.64905C8.76545 6.79141 6.92912 8.5275 4.66307 8.5275Z",
    fill: "url(#paint0_linear_2619_7206)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66262 4.64901C6.3892 4.64901 7.89707 3.76196 8.70317 2.44382C7.89707 1.12567 6.3892 0.238625 4.66262 0.238625C2.93603 0.238625 1.42817 1.12567 0.62207 2.44382C1.42894 3.76196 2.93603 4.64901 4.66262 4.64901Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2619_7206",
    x1: 1.15426,
    y1: 11.0673,
    x2: 5.06537,
    y2: 3.06331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_7206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33005,
    height: 9.33005,
    fill: "white",
    transform: "translate(0 0.238655)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaCoin);
export default __webpack_public_path__ + "static/media/ninja-coin.b4410ab7b8fb5d1bdec7753eed69f842.svg";
export { ForwardRef as ReactComponent };